import React from 'react';
import {makeStyles} from '@mui/styles';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import {BottoneInizioPagina} from "../bottoni/BottoneInizioPagina";
import {BottoneFinePagina} from "../bottoni/BottoneFinePagina";
import {Button, Grid} from "@mui/material";

const useRowStyles = makeStyles({
    root: {
        '& > *': {
            borderBottom: 'unset',
        },
    },
});

function createData(
    Cassa: string,
    data: string,
    ora: string,
    utente: string,
    rigo: string,
    totale: number,
    history: Object[]
) {
    return {
        Cassa,
        data,
        ora,
        utente,
        rigo,
        totale,
        history: history
    };
}

function Row(props: { row: ReturnType<typeof createData> }) {
    const {row} = props;
    const [open, setOpen] = React.useState(false);
    const classes = useRowStyles();
    try {
        return (
            <React.Fragment>
                <TableRow classID={classes.root}>
                    <TableCell>
                        <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                            {open ? <KeyboardArrowUpIcon/> : <KeyboardArrowDownIcon/>}
                        </IconButton>
                    </TableCell>
                    <TableCell component="th" scope="row" align="right">{row.Cassa}</TableCell>
                    <TableCell align="right">{row.ora}</TableCell>
                    <TableCell align="right">{row.utente}</TableCell>
                    <TableCell align="right">{row.rigo}</TableCell>
                    <TableCell align="right">{row.totale}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell style={{paddingBottom: 0, paddingTop: 0}} colSpan={6}>
                        <Collapse in={open} timeout="auto" unmountOnExit>
                            <Box style={{backgroundColor: '#ECECFB'}} margin={1}>
                                <Typography variant="h6" gutterBottom component="div">
                                    Dettaglio vendita
                                </Typography>
                                <Table size="small" aria-label="purchases">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Rigo</TableCell>
                                            <TableCell>ID Articolo</TableCell>
                                            <TableCell>Descrizione</TableCell>
                                            <TableCell align="right">Quantità</TableCell>
                                            <TableCell align="right">Prezzo</TableCell>
                                            <TableCell align="right">Sconto</TableCell>
                                            <TableCell align="right">Importo</TableCell>
                                            <TableCell align="right">Note</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {row.history.map((historyRow, index) => (
                                            <TableRow key={index}>
                                                <TableCell component="th" scope="row">
                                                    {historyRow.rigo}
                                                </TableCell>
                                                <TableCell>{historyRow.id}</TableCell>
                                                <TableCell>{historyRow.descrizione}</TableCell>
                                                <TableCell align="right">{historyRow.quantita}</TableCell>
                                                <TableCell align="right">{historyRow.prezzo}</TableCell>
                                                <TableCell align="right">{historyRow.sconto}</TableCell>
                                                <TableCell align="right">{historyRow.importo}</TableCell>
                                                <TableCell align="right">{historyRow.note}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </Box>
                        </Collapse>
                    </TableCell>
                </TableRow>
            </React.Fragment>
        )
    } catch (e) {
        return null
    }
}

function display() {
    window.print();
}

export default function CollapsibleTableIncassi(rows) {
    let rowsv2 = [];
    console.log(rows);
    for (let i = 0; i < rows.length; i++) {
        rowsv2.push(createData(rows[i].Cassa, rows[i].data, rows[i].ora, rows[i].utente, rows[i].rigo, rows[i].totale, rows[i].history))
    }
    try {
        return (
            <Grid container direction="column" spacing={3}>
                <Grid item>
                    <BottoneFinePagina/>
                </Grid>
                <Grid item>
                    <TableContainer component={Paper}>
                        <Table aria-label="collapsible table">
                            <TableHead>
                                <TableRow>
                                    <TableCell/>
                                    <TableCell align="right">Cassa</TableCell>
                                    <TableCell align="right">Ora</TableCell>
                                    <TableCell align="right">Utente</TableCell>
                                    <TableCell align="right">Rigo</TableCell>
                                    <TableCell align="right">Totale</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rowsv2.map((row, index) => (
                                    <Row key={index} row={row}/>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
                <Grid item>
                    <Grid container direction="row" spacing={3}>
                        <Grid item>
                            <BottoneInizioPagina/>
                        </Grid>
                        <Grid item>
                            <Button variant="contained"
                                    onClick={(e) => display()}
                            >STAMPA</Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

        )
    } catch (e) {
        return null
    }


}
